export default __webpack_public_path__ + "static/media/walleticon.1d31f2e0.png";